(function () {
  const TIRE_ORDER_RECIPIENT = "karla@area27.ca";
  const state = { catalog: [], filtered: [], selected: null, cart: [] };
  const money = new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD" });
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const compact = (value) => String(value == null ? "" : value).trim();
  const esc = (value) => String(value == null ? "" : value).replace(/[&<>"']/g, (char) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" })[char]);

  function root() {
    return $("#area27-tireorders");
  }

  function optionLabel(item) {
    const price = typeof item.price === "number" ? " - " + money.format(item.price) : "";
    return [item.ipCode || item.sku, item.size, item.product, item.description].filter(Boolean).join(" | ") + price;
  }

  function seasonUse(item) {
    return compact(item.season || item.marketSegment || item.usage || "General");
  }

  function uniqueValues(field, items) {
    return Array.from(new Set((items || state.filtered).map((item) => compact(item[field])).filter(Boolean))).sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
  }

  function setOptions(select, values, selected) {
    const current = selected || select.value;
    select.innerHTML = '<option value="">All</option>' + values.map((value) => '<option value="' + esc(value) + '">' + esc(value) + "</option>").join("");
    select.value = values.includes(current) ? current : "";
  }

  function matchesSearch(item, term) {
    if (!term) return true;
    return [item.ipCode, item.sku, item.description, item.product, item.size, item.upc, item.ean, item.category, item.season, item.usage, item.marketSegment, item.make, item.model].join(" ").toLowerCase().includes(term.toLowerCase());
  }

  function filteredCatalog(filters) {
    return state.catalog.filter((item) => {
      if (filters.category && item.category !== filters.category) return false;
      if (filters.season && seasonUse(item) !== filters.season) return false;
      if (filters.product && item.product !== filters.product) return false;
      if (filters.size && item.size !== filters.size) return false;
      return matchesSearch(item, filters.term);
    });
  }

  function currentFilters() {
    return {
      category: $("#category", root()).value,
      season: $("#season", root()).value,
      product: $("#product", root()).value,
      size: $("#size", root()).value,
      term: $("#search", root()).value.trim(),
    };
  }

  function applyFilters(keepItem) {
    const filters = currentFilters();
    const categories = uniqueValues("category", state.catalog);
    const seasonScope = filteredCatalog({ category: filters.category, season: "", product: "", size: "", term: filters.term });
    const seasons = Array.from(new Set(seasonScope.map(seasonUse).filter(Boolean))).sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
    const productScope = filteredCatalog({ category: filters.category, season: filters.season, product: "", size: "", term: filters.term });
    const products = uniqueValues("product", productScope);
    const sizeScope = filteredCatalog({ category: filters.category, season: filters.season, product: filters.product, size: "", term: filters.term });
    const sizes = uniqueValues("size", sizeScope);
    state.filtered = filteredCatalog(filters);
    setOptions($("#category", root()), categories, filters.category);
    setOptions($("#season", root()), seasons, filters.season);
    setOptions($("#product", root()), products, filters.product);
    setOptions($("#size", root()), sizes, filters.size);
    renderItemDropdown(keepItem);
  }

  function clearControls(ids) {
    ids.forEach((id) => {
      const el = $("#" + id, root());
      if (el) el.value = "";
    });
  }

  function renderItemDropdown(keepItem) {
    const select = $("#item", root());
    const previous = keepItem ? select.value : "";
    const items = state.filtered.slice(0, 700);
    select.innerHTML = '<option value="">Choose a tire</option>' + items.map((item) => '<option value="' + esc(item.id) + '">' + esc(optionLabel(item)) + "</option>").join("");
    if (previous && items.some((item) => item.id === previous)) select.value = previous;
    if (state.filtered.length > 700) {
      const option = document.createElement("option");
      option.disabled = true;
      option.textContent = "Keep filtering to narrow " + state.filtered.length + " rows";
      select.appendChild(option);
    }
  }

  function renderSummary(meta) {
    const sources = meta && meta.sourceCounts ? meta.sourceCounts : {};
    const sourceCount = Object.keys(sources).length || 4;
    $("#a27-tire-summary", root()).innerHTML = [
      ["Catalogue", sourceCount + " sheets"],
      ["Rows", String((meta && meta.totalRows) || state.catalog.length)],
      ["Source", "2026 Pirelli"],
      ["Request To", "Karla"],
    ].map(([label, value]) => "<div><span>" + esc(label) + "</span><strong>" + esc(value) + "</strong></div>").join("");
  }

  function renderDetail() {
    const box = $("#tire-detail", root());
    const item = state.selected;
    if (!item) {
      box.innerHTML = '<p class="a27-to__empty">Use the dropdowns to select a tire.</p>';
      return;
    }
    const specs = [
      ["Catalogue", item.category],
      ["IP / SKU", item.ipCode || item.sku],
      ["Size", item.size],
      ["Product", item.product],
      ["Season / use", seasonUse(item)],
      ["Load / speed", item.loadSpeed],
      ["UPC", item.upc],
      ["EAN", item.ean],
      ["Source", [item.sourceFile, item.sourceSheet, item.sourceRow ? "row " + item.sourceRow : ""].filter(Boolean).join(" / ")],
    ].filter((entry) => compact(entry[1]));
    const rows = Object.entries(item.sourceFields || {}).filter(([, value]) => compact(typeof value === "object" ? (value.value || value.formula) : value)).map(([key, value]) => {
      const shown = typeof value === "object" ? (value.value || value.formula) : value;
      return "<tr><th>" + esc(key) + "</th><td>" + esc(shown) + "</td></tr>";
    }).join("");
    box.innerHTML = '<div class="a27-to__detail-head"><div><p class="a27-to__eyebrow">Selected tire</p><h3>' + esc(item.description || item.product || item.size) + "</h3></div><strong>" + (typeof item.price === "number" ? money.format(item.price) : "Price TBC") + '</strong></div><div class="a27-to__spec-grid">' + specs.map(([label, value]) => "<div><span>" + esc(label) + "</span><strong>" + esc(value) + "</strong></div>").join("") + "</div><details><summary>Spreadsheet row details</summary><table>" + rows + "</table></details>";
  }

  function renderCart() {
    const linesBox = $("#cart-lines", root());
    if (!state.cart.length) {
      linesBox.innerHTML = '<p class="a27-to__empty">No tires added yet.</p>';
      $("#cart-total", root()).textContent = "$0.00";
      return;
    }
    let total = 0;
    linesBox.innerHTML = state.cart.map((line) => {
      const price = typeof line.item.price === "number" ? line.item.price : 0;
      const subtotal = price * line.quantity;
      total += subtotal;
      return '<div class="a27-to__cart-line"><div><strong>' + esc(line.item.size || line.item.ipCode || line.item.sku) + "</strong><span>" + esc(line.item.description || line.item.product) + "</span><small>" + esc(line.item.ipCode || line.item.sku || "") + " / Qty " + line.quantity + '</small></div><div><em>' + money.format(subtotal) + '</em><button type="button" data-remove-line="' + esc(line.item.id) + '">Remove</button></div></div>';
    }).join("");
    $("#cart-total", root()).textContent = money.format(total);
    $$("[data-remove-line]", root()).forEach((button) => {
      button.onclick = () => {
        state.cart = state.cart.filter((line) => line.item.id !== button.dataset.removeLine);
        renderCart();
      };
    });
  }

  function addLine() {
    if (!state.selected) {
      alert("Choose a tire first.");
      return;
    }
    const quantity = Number($("#quantity", root()).value);
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 24) {
      alert("Choose a whole-number quantity between 1 and 24.");
      return;
    }
    const existing = state.cart.find((line) => line.item.id === state.selected.id);
    if (existing && existing.quantity + quantity > 24) {
      alert("A maximum of 24 tires per item can be requested.");
      return;
    }
    if (existing) existing.quantity += quantity;
    else state.cart.push({ item: state.selected, quantity });
    renderCart();
  }

  function buildOrderPayload(form) {
    const formData = new FormData(form);
    const value = (name) => compact(formData.get(name));
    const required = (name, label) => {
      const result = value(name);
      if (!result) throw new Error(label + " is required.");
      return result;
    };
    const memberNumber = required("membership_number", "Member number");
    const name = required("member_name", "Your name");
    const email = required("email", "Email address");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) throw new Error("Enter a valid email address.");
    const phone = required("phone", "Phone");
    const clubRacing = value("club_racing");
    if (!["yes", "no"].includes(clubRacing)) throw new Error("Select Yes or No for Club Racing tires.");
    const delivery = value("delivery");
    if (!["Area 27 pickup", "BC drop ship"].includes(delivery)) throw new Error("Choose Area 27 pickup or British Columbia shipping.");
    let shippingAddress = null;
    if (delivery === "BC drop ship") {
      const postal = required("shipping_postal", "Postal code").toUpperCase().replace(/\s/g, "");
      if (value("shipping_province") !== "BC" || value("shipping_country") !== "Canada" || !/^V\d[ABCEGHJ-NPRSTV-Z]\d[ABCEGHJ-NPRSTV-Z]\d$/.test(postal)) throw new Error("Enter a valid British Columbia address and postal code beginning with V. Contact Karla directly about prize exceptions.");
      shippingAddress = {
        street: required("shipping_street", "Street address"), unit: value("shipping_unit"),
        city: required("shipping_city", "City"), province: "BC", country: "Canada",
        postal: postal.slice(0, 3) + " " + postal.slice(3),
      };
    }
    const vehicle = { make: required("vehicle_make", "Vehicle make"), model: required("vehicle_model", "Vehicle model"), year: Number(value("vehicle_year")) };
    if (!Number.isInteger(vehicle.year) || vehicle.year < 1900 || vehicle.year > new Date().getFullYear() + 2) throw new Error("Enter a valid vehicle year.");
    if (["accept_pricing", "accept_shipping", "accept_returns"].some((name) => value(name) !== "on")) throw new Error("Accept all three policies before preparing the order email.");
    if (!state.cart.length || state.cart.some((line) => !state.catalog.some((item) => item.id === line.item.id) || !Number.isInteger(line.quantity) || line.quantity < 1 || line.quantity > 24)) throw new Error("Add valid catalogue tires and quantities before preparing the order.");
    const reference = "A27-TIRE-" + crypto.randomUUID();
    const lines = state.cart.map((line) => {
      const item = line.item;
      const subtotal = typeof item.price === "number" ? item.price * line.quantity : null;
      return { description: item.description || item.product, product: item.product, size: item.size, ipCode: item.ipCode || item.sku, sourceFile: item.sourceFile, quantity: line.quantity, unitPrice: item.price, subtotal };
    });
    const estimatedSubtotal = lines.reduce((sum, line) => sum + (typeof line.subtotal === "number" ? line.subtotal : 0), 0);
    return {
      reference,
      recipient: TIRE_ORDER_RECIPIENT,
      memberNumber, clubRacing, shippingAddress, vehicle,
      agreements: { pricing: true, shipping: true, returns: true, acceptedAt: new Date().toISOString() },
      contact: {
        name, email, phone, delivery,
        notes: formData.get("notes") || "",
      },
      lines,
      estimatedSubtotal,
    };
  }

  function buildOrderEmail(payload) {
    const lineText = payload.lines.map((line, index) => [
      (index + 1) + ". " + (line.description || ""),
      "   Size: " + (line.size || "N/A"),
      "   IP code: " + (line.ipCode || "N/A"),
      "   Tire model: " + (line.product || "N/A"),
      "   Catalogue: " + (line.sourceFile || "N/A"),
      "   Qty: " + line.quantity,
      "   Unit price: " + (typeof line.unitPrice === "number" ? money.format(line.unitPrice) : "Price TBC"),
      "   Line subtotal: " + (typeof line.subtotal === "number" ? money.format(line.subtotal) : "Price TBC")
    ].join("\n")).join("\n\n");
    const body = [
      "Area 27 Pirelli Tire Order Request", "", "Reference: " + payload.reference, "",
      "Customer", "Name: " + payload.contact.name, "Email: " + payload.contact.email, "Phone: " + payload.contact.phone, "Pickup / install request: " + payload.contact.delivery, "",
      "Member number: " + payload.memberNumber,
      "Club Racing tires (GT27 or GT54): " + (payload.clubRacing === "yes" ? "Yes" : "No"),
      "Shipping address: " + (payload.shippingAddress ? [payload.shippingAddress.street, payload.shippingAddress.unit, payload.shippingAddress.city, "British Columbia", payload.shippingAddress.postal, "Canada"].filter(Boolean).join(", ") : "Area 27 pickup"),
      "", "Vehicle details", "Make: " + payload.vehicle.make, "Model: " + payload.vehicle.model, "Year: " + payload.vehicle.year, "",
      "Tires", lineText || "No tire lines provided.", "", "Estimated subtotal: " + money.format(payload.estimatedSubtotal || 0), "", "Notes", payload.contact.notes || "",
      "", "Terms & conditions acknowledged",
      "Pricing policy: " + (payload.agreements.pricing ? "Accepted - I agree to the price listed on the spreadsheet." : "Not accepted"),
      "Shipping policy: " + (payload.agreements.shipping ? "Accepted - Shipping only to Area 27 or a valid British Columbia address; no shipping outside BC." : "Not accepted"),
      "Returns & exchanges: " + (payload.agreements.returns ? "Accepted - No returns or exchanges." : "Not accepted"),
      "Acknowledged at (UTC): " + payload.agreements.acceptedAt
    ].join("\n");
    return "mailto:" + encodeURIComponent(TIRE_ORDER_RECIPIENT) + "?subject=" + encodeURIComponent("Area 27 Pirelli tire order - " + payload.reference) + "&body=" + encodeURIComponent(body);
  }

  function submitOrder(event) {
    event.preventDefault();
    if (!state.cart.length) {
      alert("Add at least one tire before creating the order email.");
      return;
    }
    if (!event.currentTarget.reportValidity()) return;
    let payload;
    try { payload = buildOrderPayload(event.currentTarget); }
    catch (error) { alert(error.message); return; }
    const mailto = buildOrderEmail(payload);
    const result = $("#mock-result", root());
    result.hidden = false;
    result.innerHTML = "<strong>" + esc(payload.reference) + "</strong><br>Email prepared for Karla. Send it from your mail app to submit the request. Nothing has been charged.<br><a href=\"" + esc(mailto) + '\">Open the order email again</a>';
    window.location.href = mailto;
  }

  window.Area27PirelliBoot = function (catalog, meta) {
    if (!root()) return;
    state.catalog = Array.isArray(catalog) ? catalog : [];
    state.filtered = state.catalog.slice();
    renderSummary(meta || {});
    applyFilters(false);
    renderDetail();
    $("#category", root()).addEventListener("change", () => { clearControls(["season", "product", "size", "item"]); state.selected = null; applyFilters(false); renderDetail(); });
    $("#season", root()).addEventListener("change", () => { clearControls(["product", "size", "item"]); state.selected = null; applyFilters(false); renderDetail(); });
    $("#product", root()).addEventListener("change", () => { clearControls(["size", "item"]); state.selected = null; applyFilters(false); renderDetail(); });
    $("#size", root()).addEventListener("change", () => { clearControls(["item"]); state.selected = null; applyFilters(false); renderDetail(); });
    $("#search", root()).addEventListener("input", () => applyFilters(true));
    $("#item", root()).addEventListener("change", (event) => { state.selected = state.catalog.find((item) => item.id === event.target.value) || null; renderDetail(); });
    $("#reset-filters", root()).addEventListener("click", () => { ["category", "season", "product", "size", "item"].forEach((id) => $("#" + id, root()).value = ""); $("#search", root()).value = ""; state.selected = null; applyFilters(false); renderDetail(); });
    $("#add-line", root()).addEventListener("click", addLine);
    $("#mock-order-form", root()).addEventListener("submit", submitOrder);
    const updateShipping = () => {
      const shipping = $("#delivery", root()).value === "BC drop ship";
      $("#shipping-fields", root()).hidden = !shipping;
      $("#shipping-fields", root()).disabled = !shipping;
    };
    $("#delivery", root()).addEventListener("change", updateShipping);
    updateShipping();
  };
})();
